var $54b47fc030b7b21e$exports = {};
var $54b47fc030b7b21e$var$range = document.querySelector(".slider-range");
var $54b47fc030b7b21e$var$imageAfter = document.querySelector(".slider-image-after");
var $54b47fc030b7b21e$var$separator = document.querySelector(".slider-separator");
var $54b47fc030b7b21e$var$textBefore = document.querySelector(".slider-text-before");
var $54b47fc030b7b21e$var$textAfter = document.querySelector(".slider-text-after");
var $54b47fc030b7b21e$var$handler = document.querySelector(".slider-handler");
var $54b47fc030b7b21e$var$updatePosition = function() {
    var rawValue = parseInt($54b47fc030b7b21e$var$range.value);
    var sliderWidth = document.querySelector(".slider").offsetWidth;
    var minLimit = 250 / sliderWidth * 100;
    var maxLimit = 100 - minLimit;
    var limitedValue = Math.max(minLimit, Math.min(rawValue, maxLimit));
    if (limitedValue !== rawValue) $54b47fc030b7b21e$var$range.value = limitedValue;
    var position = limitedValue + "%";
    $54b47fc030b7b21e$var$imageAfter.style.width = position;
    $54b47fc030b7b21e$var$separator.style.left = position;
    var normalizedPosition = (limitedValue - minLimit) / (maxLimit - minLimit);
    $54b47fc030b7b21e$var$handler.classList.remove("slider-handler-left", "slider-handler-middle", "slider-handler-right");
    if (normalizedPosition < 0.33) $54b47fc030b7b21e$var$handler.classList.add("slider-handler-left");
    else if (normalizedPosition > 0.66) $54b47fc030b7b21e$var$handler.classList.add("slider-handler-right");
    else $54b47fc030b7b21e$var$handler.classList.add("slider-handler-middle");
    var beforeOpacity, afterOpacity;
    if (normalizedPosition <= 0.5) {
        beforeOpacity = 1 - normalizedPosition;
        afterOpacity = normalizedPosition;
    } else {
        beforeOpacity = 0.5 - (normalizedPosition - 0.5);
        afterOpacity = 0.5 + (normalizedPosition - 0.5);
    }
    $54b47fc030b7b21e$var$textBefore.style.opacity = beforeOpacity;
    $54b47fc030b7b21e$var$textAfter.style.opacity = afterOpacity;
};
$54b47fc030b7b21e$var$updatePosition();
$54b47fc030b7b21e$var$range.addEventListener("input", $54b47fc030b7b21e$var$updatePosition);


//# sourceMappingURL=index.da0af3d6.js.map
